import { ActionIcon } from '@mantine/core'
import cn from 'classnames'

import { FaIcon } from '#components/FaIcon'

import styles from './ExpandIcon.module.css'

export const EXPAND_ICON_WIDTH = 30

export const ExpandIcon = ({
  expanded,
  width,
  variant = 'folder',
}: {
  expanded: boolean
  width: number
  variant?: 'folder' | 'header'
}) => {
  const isFolder = variant === 'folder'

  return (
    <div className={styles.wrapper} style={{ width, minWidth: width }}>
      <ActionIcon
        c="dimmed"
        size={width}
        className={cn(styles.expand, {
          [styles.folder]: isFolder,
        })}
      >
        <FaIcon
          icon="fa-chevron-right"
          size={isFolder ? '10' : '14'}
          className={cn(styles.expand, {
            [styles.expand___rotate]: expanded,
          })}
        />
      </ActionIcon>
    </div>
  )
}
